import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Chip,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useTranslation } from 'react-i18next';

const sections = [
  {
    key: 'product_flow',
    title: '商品上架流程',
    items: [
      '前往「商品管理」新增商品，填寫名稱、售價、庫存與分類。',
      '若有規格商品，先建立規格再補上對應價格。',
      '儲存後到前台商品頁確認顯示與價格是否正確。',
    ],
  },
  {
    key: 'order_flow',
    title: '訂單與出貨流程',
    items: [
      '到「訂單管理」確認新訂單付款狀態。',
      '出貨後更新物流狀態與追蹤編號。',
      '到前台訂單查詢頁確認客戶可看到最新狀態。',
    ],
  },
  {
    key: 'store_settings',
    title: '商店設定檢查',
    items: [
      '在「商店設定」更新品牌名稱、Logo、聯絡資訊。',
      '在「SEO 設定」填入標題、描述、關鍵字與驗證碼。',
      '在「運費設定」調整基本運費與免運門檻。',
    ],
  },
  {
    key: 'multi_lang',
    title: '多國語系驗證',
    items: [
      '切換語言後檢查側欄、儀表板、商品與訂單頁文字。',
      '若看到 key（如 admin.xxx）外露，代表該語系缺字。',
      '修正後重新整理並回前台/後台各頁再驗證一次。',
    ],
  },
  {
    key: 'go_live',
    title: '上線前清單',
    items: [
      '前台：首頁、商品列表、商品詳情、購物車、結帳流程。',
      '後台：商品、訂單、會員、商店設定、通知設定。',
      '平台：申請流程、租戶狀態、申請審核與篩選統計。',
    ],
  },
];

function AdminManual() {
  const { t } = useTranslation('manual');

  return (
    <Box>
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1.5 }}>
            <MenuBookIcon color="primary" />
              <Typography variant="h5" fontWeight={800}>
              {t('title')}
              </Typography>
          </Stack>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            {t('subtitle')}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Chip size="small" color="primary" label={t('chip_1')} />
            <Chip size="small" color="primary" label={t('chip_2')} />
            <Chip size="small" color="primary" label={t('chip_3')} />
            <Chip size="small" color="primary" label={t('chip_4')} />
          </Stack>
        </CardContent>
      </Card>

      {sections.map((section) => (
        <Accordion key={section.key} defaultExpanded={section.key === 'product_flow'}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight={700}>{t(`sections.${section.key}.title`, { defaultValue: section.title })}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack spacing={1.2}>
              {section.items.map((item, idx) => (
                <Typography key={item} variant="body2" color="text.secondary">
                  {idx + 1}. {t(`sections.${section.key}.item_${idx + 1}`, { defaultValue: item })}
                </Typography>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}

      <Divider sx={{ my: 2.5 }} />

      <Typography variant="body2" color="text.secondary">
        {t('footer')}
      </Typography>
    </Box>
  );
}

export default AdminManual;
